import React from 'react';
import { Link } from 'react-router-dom';
import '../css/NotFoundPage.css';

const NotFoundPage = ({ attemptedPath = '' }) => {
  return (
    <div className="notfound-shell">
      <div className="notfound-card">
        <div className="notfound-topbar">
          <div className="notfound-brand">BlinkURL</div>
          <div className="notfound-links">
            <Link to="/dashboard">Dashboard</Link>
            <Link to="/pricing">Pricing</Link>
            <Link to="/support">Help</Link>
            <Link to="/login" className="login-pill">Login</Link>
          </div>
        </div>

        <div className="notfound-content">
          <h1>404</h1>
          <h2>Oops! Page Not Found</h2>
          <p>
            The link is broken or the page you&apos;re looking for doesn&apos;t exist.
            {attemptedPath ? ` (${attemptedPath})` : ''}
          </p>

          <div className="broken-chain" aria-hidden="true">
            <div className="chain left"></div>
            <div className="chain right"></div>
            <span className="spark one"></span>
            <span className="spark two"></span>
            <span className="spark three"></span>
          </div>

          <Link to="/" className="home-btn">Go Back Home</Link>
        </div>
      </div>
    </div>
  );
};

export default NotFoundPage;
